export const policies = [
  {
    title: "Free Delivery",
    details: "For all orders over $99",
    icon: "directionsrun",
  },
  { title: "90 Days Return", details: "If goods have problems", icon: "loop" },
  { title: "Secure Payment", details: "100% secure payment", icon: "payment" },
  { title: "24/7 Support", details: "Dedicated support ", icon: "forum" },
  { title: "Gift Service", details: "Support gift service", icon: "redeem" },
];
